<div class="property-sell_mobile-header">
    <a [href]="tradeMeUrl">
        <img
            class="tm-logo-svg"
            src="assets/trademe-core-ui/new_tm_logo.svg"
            alt="Where kiwis sell their properties"
        />
    </a>
    <div class="member-info" [class.is-webview]="isWebview">
        <a class="my-trademe h-link-no-visited" [href]="myTradeMeUrl">
            <span class="my-trademe-text">My Trade Me </span>
            <span
                class="user-avatar"
                [style.background-image]="'url(\'' + myPhotoUrl + '\')'"
            >
            </span>
        </a>
    </div>
</div>
<hr class="header-line-separator" />
